/* import axios from "axios";

export const REFRESH_DASHBOARD = "REFRESH_DASHBOARD";

// Action pour récupérer les disciplines avec le nombre de rencontres
export const refreshDashboard = () => async (dispatch) => {
  try {
    const res = await axios.get(
      "http://localhost:8000/api/nb_rencontres_par_discipline/"
    );
    dispatch({
      type: REFRESH_DASHBOARD,
      payload: res.data,
    });
  } catch (err) {
    console.error("Erreur dashboard:", err);
    dispatch({
      type: REFRESH_DASHBOARD,
      payload: [],
    });
  }
};
*/

// actions/dashboard.js
import axios from "axios";

// Types d'actions
export const REFRESH_DASHBOARD_REQUEST = "REFRESH_DASHBOARD_REQUEST";
export const REFRESH_DASHBOARD_SUCCESS = "REFRESH_DASHBOARD_SUCCESS";
export const REFRESH_DASHBOARD_FAILURE = "REFRESH_DASHBOARD_FAILURE";
export const UPDATE_RENCONTRE_STATUS = "UPDATE_RENCONTRE_STATUS";

// Action pour rafraîchir le dashboard
export const refreshDashboard = () => async (dispatch) => {
  dispatch({ type: REFRESH_DASHBOARD_REQUEST });

  try {
    // Remplacez cette URL par votre endpoint API pour récupérer les données du dashboard
    const response = await axios.get(
      "http://localhost:8000/api/nb_rencontres_par_discipline/"
    );

    dispatch({
      type: REFRESH_DASHBOARD_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: REFRESH_DASHBOARD_FAILURE,
      payload: error.message,
    });
  }
};

// Action pour mettre à jour le statut d'une rencontre
export const updateRencontreStatus = (rencontreData) => ({
  type: UPDATE_RENCONTRE_STATUS,
  payload: rencontreData,
});
